import React, { useEffect, useState, useCallback, useRef } from "react";
import BlogListElement from "./BlogListElement";
import Loading from "../../assets/containers/loadingDialog";
import { useDispatch, useSelector } from "react-redux";
import BlogRequests from "../../assets/services/blog";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const itemContainer = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

const BlogsContent = () => {
  const dispatch = useDispatch();
  const { allBlogs, bLogFilter, blogTotalPages, loadingBlogData } = useSelector(
    ({ blog }) => blog
  );
  const [page, setPage] = useState(1);

  const observer = useRef();

  useEffect(() => {
    const fetchMoreData = async () => {
      dispatch(BlogRequests.getAllblogs(bLogFilter, page));
    };
    if (page !== 1) {
      fetchMoreData();
    }
  }, [page]);

  const lastElementRef = useCallback(
    (node) => {
      if (loadingBlogData) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page < blogTotalPages) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loadingBlogData, page, blogTotalPages]
  );

  const blogElements = allBlogs.map((blog, index) => {
    return (
      <motion.div
        variants={itemContainer}
        key={blog._id}
        ref={index === allBlogs.length - 1 ? lastElementRef : null}
      >
        <BlogListElement data={blog} />
      </motion.div>
    );
  });

  return (
    <>
      {allBlogs ? (
        allBlogs.length !== 0 ? (
          <motion.div
            variants={container}
            initial="hidden"
            animate="visible"
            className="w-100"
          >
            {blogElements}
            {loadingBlogData && (
              <Loading
                className={"w-100 d-flex justify-content-center my-5 py-5"}
              />
            )}
          </motion.div>
        ) : (
          <NoResultAlter className={"w-100  py-5 my-5"} />
        )
      ) : (
        <NoResultAlter className={"w-100  py-5 my-5"} />
      )}
    </>
  );
};

export default BlogsContent;
